import type { JSX } from 'react';

import { Helmet } from 'react-helmet-async';

import { useMetaRobots } from './hooks/useMetaRobots';

export function MetaRobots(): JSX.Element | null {
	const {
		data: { indexed },
	} = useMetaRobots();

	if (indexed) return null;

	return (
		<Helmet>
			<meta name="robots" content="noindex" />
		</Helmet>
	);
}
